// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"143":"css/app_pop","304":"css/app_admin","453":"css/app_series","629":"css/app_deco","811":"css/app_series_old"}[chunkId] + ".css";
};